import { Mock, enable, disable } from 'lib/MockLib';
import ApiService from '../ApiService';

@Mock(ApiService)
class ApiServiceMock {
  @enable
  getCurrentUser(params) {
    return {
      data: {
        logged: true,
        isAdmin: false,
        isPro: true,
        email: 'moshe@gmail.com',
      },
    };
  }
}
